import { EditorContent } from "@tiptap/react";
import { RefObject, useMemo } from "react";

import { GenerationGeniusAPIResponse } from "@/types/models/GenerationGenius.interface";
import useGeniusEditor from "@/view/GeniusContent/utils/useGeniusEditor/useGeniusEditor";
import PanelHeader from "@/view/PanelHeader";

import { Assignment } from "@/types/models/Assignment.interface";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { formatGeniusActivityPanelContent } from "../GeniusContent/utils";
import { IGeniusButtonEventProperties } from "../GeniusContent/GeniusActivityPanel/GeniusActivityPanel.constant";
import useAssignmentReducerContext from "../utils/useAssignmentReducerContext";
import {
  drawerContainerCss,
  titleCss,
} from "./GeniusVocabularyContainer.style";

interface GeniusVocabularyContainerProps {
  backButtonEventProperties: IGeniusButtonEventProperties;
  closeButtonEventProperties: IGeniusButtonEventProperties;
  onClickBackButton: () => void;
  onClickCloseButton: () => void;
  shouldFocusCloseButtonRef: RefObject<boolean>;
  contentData: GenerationGeniusAPIResponse;
}

export const GeniusVocabularyContainer = ({
  backButtonEventProperties,
  closeButtonEventProperties,
  onClickBackButton,
  shouldFocusCloseButtonRef,
  contentData,
  onClickCloseButton,
}: GeniusVocabularyContainerProps) => {
  const { updatedAssignment } = useAssignmentReducerContext() as {
    updatedAssignment: Assignment;
  };

  const { isStudent } = useGetUserProperties() || {};

  const { hide_generation_genius_vocab_definitions: hideVocabDefinitions } =
    updatedAssignment.assignment_config;

  const shouldHideVocabDefinitions = Boolean(isStudent && hideVocabDefinitions);

  const { vocabulary } = useMemo(
    () =>
      formatGeniusActivityPanelContent(contentData, shouldHideVocabDefinitions),
    [contentData.vocabulary, shouldHideVocabDefinitions],
  );
  const editor = useGeniusEditor({ content: vocabulary });

  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        backButtonEventProperties={backButtonEventProperties}
        closeButtonEventProperties={closeButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Vocabulary</h2>
      </PanelHeader>

      <div css={drawerContainerCss}>
        <EditorContent editor={editor} />
      </div>
    </>
  );
};

export default GeniusVocabularyContainer;
